module.exports = __webpack_public_path__ + "static/media/Gel_s_kyselinou_hyaluronovou_CBD_retina.5379644c.png";